import './LoadingOverlay.css'

interface LoadingOverlayProps {
  isLoading?: boolean
  message?: string
}

export const LoadingOverlay = ({ isLoading = true, message }: LoadingOverlayProps) => {
  return (
        <div className={`loading-overlay ${isLoading ? 'show' : ''}`}>
            <div className={`spinner ${isLoading ? 'show' : ''}`} />
            {message && <div className="loading-message">{message}</div>}
        </div>
  )
}
